// extracted by mini-css-extract-plugin
export var ShareButtons = "shareButtons-module--ShareButtons--21f6d";
export var ShareButtons_links = "shareButtons-module--ShareButtons_links--19cb8";
export var ShareButtons_title = "shareButtons-module--ShareButtons_title--6378b";
export var slideIn = "shareButtons-module--slide-in--ea18f";
export var slideInFromRight = "shareButtons-module--slide-in-from-right--66c9d";